export default "__VITE_ASSET__76e24d84__"